/**
 * v4 (server availability.py, docs/PLAN_V4_TANG_CUONG_WEB_2026-10-29.md section 4): is a render machine on for the
 * queue an action needs? From GET /api/status `queues`, asked again every 30 s while the page is visible (App.tsx).
 * The server refuses AI queues no machine serves (503 queue_unavailable, nothing charged), so the page disables the
 * button beforehand; local / edit are accepted (the photo waits up to 10 min): a soft note only.
 */
import type { Status } from "./api";

export const STATUS_POLL_MS = 30_000;

/** Unknown (status not loaded yet, an older server without `queues`) counts as on: the server has the last word. */
export function queueOpen(status: Status | null | undefined, queue: string): boolean {
  return status?.queues?.[queue] ?? true;
}

/** The queue of an ID-photo render (server JobSettingsIn.queue). */
export const idPhotoQueue = (ai: { model?: string } | undefined): string => (!ai ? "local" : ai.model ? "cloud" : "ai");

/** The queue of an editor export with AI steps (server edit.export_queue). */
export const editAiQueue = (model: string | undefined): string => (model ? "edit-cloud" : "edit-ai");
